import React, { type PropsWithChildren, useEffect } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { sendDwh } from 'reactApp/utils/ga';

import { EditorRestrictionTooltip } from './EditorRestrictionTooltip';
import { useEditorRestrictionTooltip } from './EditorRestrictionTooltip.hooks';

interface EditorRestrictionTooltipWrapperProps {
    isEditingDisabled?: boolean;
}

export function EditorRestrictionTooltipWrapper({
    children,
    isEditingDisabled = false,
}: PropsWithChildren<EditorRestrictionTooltipWrapperProps>) {
    const { handleCloseTooltip, showTooltip, tooltipRef, handleClick } = useEditorRestrictionTooltip({
        isEditingDisabled,
    });

    useEffect(() => {
        emitAnalyticEvent(AnalyticEventNames.EDITOR_BUTTON_SHOW);
        sendDwh({ eventCategory: 'button', action: 'show', dwhData: { button_name: 'edit_files', source: 'desktop', platform: 'web' } });
    }, []);

    return (
        <>
            <div ref={tooltipRef} onClick={handleClick}>
                {children}
            </div>
            {showTooltip && <EditorRestrictionTooltip onClose={handleCloseTooltip} ref={tooltipRef} />}
        </>
    );
}
